<template>
    <div class="credit-card">
        <div class="credit-card__content">
            <div class="credit-card__number">**** **** **** {{ cardInfo.number }}</div>
            <div class="credit-card__details">
                <div class="credit-card__expiry-date">Data ważności karty: {{ cardInfo.expiration_date }}</div>

                <img
                    class="credit-card__issuer-logo"
                    :src="require(`@/assets/img/drs/${cardInfo.type.toLowerCase()}.svg`)"
                    alt="Credit card logo"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        cardInfo: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss">
.credit-card {
    border: 1px solid var(--color-gray-200);
    border-radius: 8px;
    width: 360px;
    aspect-ratio: 85.6 / 53.98;
    position: relative;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;

    &__content {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 1rem;
        background-color: var(--color-white);
        border-radius: 8px;
        box-shadow: 0 6px 4px rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
    }

    &__issuer-logo {
        max-width: 15%;
    }

    &__number {
        margin-top: 28%;
    }

    &__details {
        margin-top: 5%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
}
</style>